import { connect } from "react-redux";
import { useEffect } from "react";
import { refreshTokenRequest } from "../../../store/slices/authSlice";

const TokenHandler = ({ accessToken, refreshToken, refreshTokenRequest }) => {
  useEffect(() => {
    const interval = setInterval(() => {
      const decodeToken = (token) => {
        try {
          const base64Url = token.split(".")[1];
          const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
          const jsonPayload = decodeURIComponent(
            atob(base64)
              .split("")
              .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
              .join("")
          );
          return JSON.parse(jsonPayload);
        } catch (error) {
          return null;
        }
      };

      const decodedToken = decodeToken(accessToken);

      if (decodedToken && decodedToken.exp * 1000 - Date.now() <= 30000) {
        refreshTokenRequest({ refreshToken });
      }
    }, 10000);

    return () => clearInterval(interval);
  }, [accessToken, refreshToken, refreshTokenRequest]);

  return null;
};

const mapStateToProps = (state) => ({
  accessToken: state?.auth?.session.accessToken,
  refreshToken: state?.auth?.session.refreshToken,
});

const mapDispatchToProps = (dispatch) => ({
  refreshTokenRequest: (data) => dispatch(refreshTokenRequest(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TokenHandler);
